import React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    SelectInput,
    ReferenceInput
} from 'react-admin';
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const AdminTelephoneCreate = () => {

    return (
        <Create>
            <SimpleForm>
                <TextInput name="telephone" source="telephone" validate={[required()]} fullWidth />
                <TextInput name="description" source="description" fullWidth />
                <ReferenceInput
                    label="company"
                    source="company"
                    reference="companies"
                >
                    <SelectInput optionText="name"/>
                </ReferenceInput>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}